module Tapas.ViewModels {
    export class InstantSearchViewModel extends Tapas.ViewModels.CartViewModel {
		public searchQuery: KnockoutObservable<string>;
        public result: KnockoutObservable<string>;
        public instantSearchPageId: KnockoutObservable<number>;
        public getSearchUrl: KnockoutComputed<string>;
        public allResults = ko.observable<boolean>(false);
		public data: Ftw.Data;
        public timeOut;
        public quickOrderOpen: KnockoutObservable<boolean>;
        public AddonQueryString: KnockoutObservable<string>;
        public searchLoading: KnockoutObservable<boolean>;
                 

		constructor() {
            super();
            this.searchQuery = ko.observable("");
            this.AddonQueryString = ko.observable("");
			this.searchQuery.subscribe(this.asyncSearch);
			this.instantSearchPageId = ko.observable(0);
			this.result = ko.observable("");			
            this.data = new Ftw.Data();
            this.quickOrderOpen = ko.observable(false);
            this.searchLoading = ko.observable(false);

            this.getSearchUrl = ko.computed({
                owner: this,
                read: () => {
                    return "Default.aspx?ID=" + this.instantSearchPageId() + "&Search=" + (this.searchQuery() + this.AddonQueryString()).replace(/ /g, '+');
                }
            });

            this.allResults.subscribe(() => {
                if (this.allResults()) {
                    $(document).click((e) => {
                        var target = $(e.target);
                        var isInSearchContainer = target.closest('.js-instant-search-container');
                        if (isInSearchContainer.length == 0) {
                            this.searchQuery('');
                        }
                    })
                }
            });
		}
		
		public asyncSearch = () => {
            var query = this.searchQuery();
            clearTimeout(this.timeOut);
            this.searchLoading(false);

			if (query.length > 1) {
                this.allResults(true);
                this.searchLoading(true);

                this.timeOut = setTimeout(() => {
                    this.data.get(this.getSearchUrl())
						.then((data) => {
							this.result(data);
							if (!($(data).children().hasClass("quickOrder") || $(data).children().hasClass("instantSearchNoResult"))) {
								ko.applyBindings(this, document.getElementById(query));
                            }
                        }).finally(() => {
                            this.searchLoading(false);
                        });
				}, 250);

			} else {
				this.allResults(false);
            }            
        }
	}
} 
